import { post } from "./../api";
//* Types
// Body
type Body = {
	purchasableId: number;
	stock: string;
	qty: string;
};

// Response
type Response = {
	data: {
		cart: any;
	};
};

//* Function
export function AddPurchasableToCart(body: Body) {
	return post<Body, Response>("/actions/quantity-cart/cart/add-to-cart", body);
}
